module.exports = __webpack_public_path__ + "img/1 7.8a5118ac.png";